export const blockIconsImagePictureAsPdf = (
	<span className='material-symbols-outlined'>picture_as_pdf</span>
);
